import request from '@/plugins/request';
let Api = {};
const sys = '/user/'
const pre = 'user_info';
// 列表
Api.tableList = function (data) {
    console.log(data)
    return request({
        url: `${sys}${pre}_page`,
        method: 'get',
        params: data
    });
}
// 查看
Api.getTableById = function (id) {
    return request({
        url: `${sys}${pre}_id/${id}`,
        method: 'get'
    });
}
// 新增
Api.addTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'post',
        data
    });
}
// 编辑
Api.editTable = function (data) {
    return request({
        url: `${sys}${pre}`,
        method: 'patch',
        data
    });
}
// 删除
Api.deleteTable = function (id) {
    return request({
        url: `${sys}${pre}/${id}`,
        method: 'delete'
    });
}
// 批量删除
Api.deleteTableAll = function (ids) {
    return request({
        url: `${sys}${pre}_ids/${ids}`,
        method: 'delete'
    });
}
// 群组查用户
Api.getUsersByGroup = function (data) {
    return request({
        url: `${sys}${pre}/group_users`,
        method: 'post',
        data
    });
}
// 角色查用户
Api.getUsersByRole = function (data) {
    return request({
        url: `${sys}${pre}/role_users`,
        method: 'post',
        data
    });
}
// 部门查用户
Api.getUsersByDept = function (data) {
    return request({
        url: `${sys}${pre}/dept_users`,
        method: 'post',
        data
    });
}
export default Api



// WEBPACK FOOTER //
// ./src/api/system/user.js